// extracted by mini-css-extract-plugin
export default {"Link":"reactComponents_Link__yHWr6"};